import axios from 'axios';
import BaseAPI from './base-api';
import CurrentApplication_ from './models/CurrentRequestApplication';
import { buildRequestOptions } from '../utils/helper';

export default class CurrentApplicationsAPI extends BaseAPI {
  static getCurrentApplications() {
    const requestOptions = buildRequestOptions('api/LoanApplications/InquireCurrentRequests');

    return BaseAPI.promiseWrapper<CurrentApplication_[]>(axios(requestOptions));
  }

  static declineCurrentCoBorrowerApplication(guidQDParty: string) {
    return BaseAPI.promiseWrapper<void>(axios({
      method: 'POST',
      url: `${window.feHost}/api/LoanApplications/DeclineApplication`,
      data: JSON.stringify({ guid: guidQDParty, }),
      headers: this.getRequestHeaders(),
    }));
  }

  static withdrawCurrentApplication(idQDApplication: number) {
    return BaseAPI.promiseWrapper<void>(axios({
      method: 'POST',
      url: `${window.feHost}/api/LoanApplications/WithdrawApplication`,
      data: JSON.stringify(idQDApplication),
      headers: this.getRequestHeaders(),
    }));
  }
}
